import vacancyApi from '@/api/vacancy'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  id: 0,

  translations: [],
  typeId: 0,
  isActive: false,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  create({ commit }) {
    return vacancyApi.create(state)
      .then(({ data }) => commit('VACANCY_CREATED', data))
      .catch(error => {
        commit('VACANCY_CREATE_FAILED', error.response.data)
        throw error
      })
  },
  fetchById({ commit }, id) {
    commit('FORM_RESET')
    vacancyApi.getById(id)
      .then(({ data }) => commit('VACANCY_FETCHED', data))
      .catch(err => commit('VACANCY_FETCH_FAILED', err))
  },
  update({ commit }) {
    return vacancyApi.update(state)
      .then(({ data }) => commit('VACANCY_UPDATED', data))
      .catch(error => {
        commit('VACANCY_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  SET_LIST(state, data) {
    state.list = data
  },
  VACANCY_CREATED() {
    store.dispatch('message/success', 'VACANCY.created')
    store.dispatch('vacancy/fetchList')
  },
  VACANCY_CREATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'VACANCY.failedDealer')
  },
  VACANCY_UPDATED() {
    store.dispatch('message/success', 'VACANCY.updated')
    store.dispatch('vacancy/fetchList')
  },
  VACANCY_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'VACANCY.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  VACANCY_FETCHED(state, data) {
    Object.assign(state, data)
  },
  VACANCY_FETCH_FAILED() {
    store.dispatch('message/error', 'VACANCY.failedFetch')
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
